var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ba-w-100 ba-flex ba-ai-center ba-jc-fe"},[_c('button',{staticClass:"ba-btn ba-md ba-blue",on:{"click":function($event){return _vm.goToSitemap(_vm.website)}}},[_c('builderall-icon',{attrs:{"code":"4970"}}),_vm._v("\n        "+_vm._s(_vm.$t('ct-access-sitemap'))+"\n    ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c976f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pages/Sitemap.vue
// module id = null
// module chunks = 